var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRafRegistrationInvoiceUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 174,
    viewBox: "0 0 240 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_46616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 0H0V174H240V0Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 -8928.5H-487C-489.485 -8928.5 -491.5 -8926.49 -491.5 -8924V3440C-491.5 3442.49 -489.485 3444.5 -487 3444.5H481C483.485 3444.5 485.5 3442.49 485.5 3440V-8924C485.5 -8926.49 483.485 -8928.5 481 -8928.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 -8928.5H-487C-489.485 -8928.5 -491.5 -8926.49 -491.5 -8924V3440C-491.5 3442.49 -489.485 3444.5 -487 3444.5H481C483.485 3444.5 485.5 3442.49 485.5 3440V-8924C485.5 -8926.49 483.485 -8928.5 481 -8928.5Z",
    stroke: "#7B61FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M218.615 105.598C218.615 105.598 256.615 8.91891 156.586 7.56395C56.558 6.209 10.8213 21.0508 10.3694 70.2204C9.91754 119.39 45.9458 165.341 108.738 165.85C171.531 166.359 205.486 147.859 218.615 105.598Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M38.334 158.13V118.576H201.668V132.815L186.695 137.189L171.723 142.633L141.779 153.522L92.476 137.189L38.334 158.13Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1445 22.9121C40.9063 22.9121 38.2812 25.5371 38.2812 28.7753V151.147L92.4575 130.206L141.792 146.539L186.737 130.206L201.718 125.832V28.7753C201.718 25.5372 199.093 22.9121 195.855 22.9121H44.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.737 130.206L201.718 125.832V28.7753C201.718 25.5372 199.093 22.9121 195.855 22.9121H44.1445C40.9063 22.9121 38.2812 25.5371 38.2812 28.7753V151.147L92.4575 130.206L141.792 146.539L186.737 130.206ZM141.758 144.212L186.052 128.115L199.52 124.183V28.7753C199.52 26.7515 197.879 25.1108 195.855 25.1108H44.1445C42.1206 25.1108 40.4799 26.7515 40.4799 28.7753V147.939L92.4 127.87L141.758 144.212Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 46.3647H77.0914V48.7845H52.8008V46.3647Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 51.7163H77.0914V54.1361H52.8008V51.7163Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 63.8147H148.288V66.2344H52.8008V63.8147Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 69.1663H148.288V71.5861H52.8008V69.1663Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 74.5176H148.288V76.9373H52.8008V74.5176Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 79.8691H148.288V82.2889H52.8008V79.8691Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 85.2207H148.288V87.6404H52.8008V85.2207Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 90.572H148.288V92.9918H52.8008V90.572Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 95.9229H116.877V98.3426H52.8008V95.9229Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 46.3647H187.235V48.7845H162.945V46.3647Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 51.7163H183.047V54.1361H162.945V51.7163Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 57.0676H187.235V59.4873H162.945V57.0676Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 62.4192H183.047V64.839H162.945V62.4192Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 67.7705H183.047V70.1902H162.945V67.7705Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.945 73.1213H183.048V75.5411H162.945V73.1213Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M209.333 110.667H168V146H209.333V110.667Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.835 106H171V141.293H213.835V106Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.925 133C187.308 133 187 132.732 187 132.196V131.467C187 131.03 187.169 130.668 187.506 130.379C187.867 130.074 188.221 129.707 188.566 129.279C188.92 128.842 189.097 128.063 189.097 126.942V125.793H187.851C187.325 125.793 187.062 125.525 187.062 124.989V123.53C187.062 122.995 187.329 122.727 187.863 122.727H189.097V120.971C189.097 118.902 189.627 117.39 190.688 116.434C191.749 115.478 193.155 115 194.906 115C195.737 115 196.501 115.124 197.2 115.371C197.899 115.618 198.528 116.043 199.087 116.644C199.482 117.073 199.568 117.419 199.346 117.683L198.483 118.721C198.129 119.15 197.747 119.15 197.336 118.721C197.007 118.383 196.637 118.14 196.226 117.992C195.815 117.843 195.367 117.769 194.881 117.769C194.084 117.769 193.496 118.004 193.118 118.474C192.739 118.935 192.55 119.615 192.55 120.514V122.727H195.473C196.008 122.727 196.275 122.995 196.275 123.53V124.989C196.275 125.525 196.012 125.793 195.486 125.793H192.55V126.88C192.55 127.63 192.48 128.249 192.341 128.735C192.201 129.221 191.979 129.613 191.675 129.909V129.984C192.168 129.951 192.579 129.934 192.908 129.934H199.075C199.692 129.934 200 130.202 200 130.738V132.196C200 132.732 199.692 133 199.075 133H187.925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_46616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 174,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRafRegistrationInvoiceUk);
export default __webpack_public_path__ + "static/media/raf_registration_invoice_uk.84140d1e67d05a8beba5a7f27fd5cd16.svg";
export { ForwardRef as ReactComponent };